import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {OverlayPanelModule} from 'primeng/overlaypanel';

import {CheckboxModule} from 'primeng/checkbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {ButtonModule} from 'primeng/button';
import {MiscModule} from 'projects/core/src/public-api';
import {MatButtonModule} from '@angular/material/button';
import {MatRippleModule} from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import {SelectButtonModule} from 'primeng/selectbutton';
import {CalendarModule} from 'primeng/calendar';
import {DropdownModule} from 'primeng/dropdown';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {AccordionModule} from 'primeng/accordion';
import {ListboxModule} from 'primeng/listbox';
import {PaginatorModule} from 'primeng/paginator';
import {HomeBoardComponent} from './view/home-board/home-board.component';
import {DashBoardLeftBlockComponent} from './view/home-board/dash-board-left-block/dash-board-left-block.component';
import {DashBoardMainBlockComponent} from './view/home-board/dash-board-main-block/dash-board-main-block.component';
import {TaskColumnComponent} from './view/home-board/dash-board-main-block/task-column/task-column.component';
import {TaskCardComponent} from './view/home-board/dash-board-main-block/task-column/task-card/task-card.component';
import {
  TaskEditDialogComponent
} from './view/home-board/dash-board-main-block/task-column/task-edit-dialog/task-edit-dialog.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {
  TasksListDialogComponent
} from './view/home-board/dash-board-main-block/task-column/tasks-list-dialog/tasks-list-dialog.component';
import {
  TaskCommentsComponent
} from './view/home-board/dash-board-main-block/task-column/task-comments/task-comments.component';
import {
  AlertsColumnComponent
} from './view/home-board/dash-board-main-block/nfs-columns/alerts-column/alerts-column.component';
import {
  ClientNfsColumnComponent
} from './view/home-board/dash-board-main-block/nfs-columns/client-nfs-column/client-nfs-column.component';
import {SystemAlertsModule} from '../alerts/system-alerts.module';
import {ClientNfsModule} from '../../view/notification/notification.module';
import {
  TaskCheckitemComponent
} from './view/home-board/dash-board-main-block/task-column/task-checkitem/task-checkitem.component';
import {
  AddTaskCheckitemComponent
} from './view/home-board/dash-board-main-block/task-column/task-checkitem/add-task-checkitem/add-task-checkitem.component';
import {
  EditTaskCheckitemComponent
} from './view/home-board/dash-board-main-block/task-column/task-checkitem/edit-task-checkitem/edit-task-checkitem.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {
  EditWorkOrderItemsComponent
} from './view/home-board/dash-board-main-block/task-column/task-checkitem/edit-work-order-items/edit-work-order-items.component';
import {ProgressBarModule} from 'primeng/progressbar';
import {
  TaskCheckitemTagsComponent
} from './view/home-board/dash-board-main-block/task-column/task-checkitem/task-checkitem-tags/task-checkitem-tags.component';
import {InputNumberModule} from 'primeng/inputnumber';
import {TooltipModule} from 'primeng/tooltip';
import {
  MentionsColumnComponent
} from './view/home-board/dash-board-main-block/nfs-columns/mentions-column/mentions-column.component';
import {NotificationModule} from 'projects/app-misc/src/app/modules/notification/notification.module';
import {
  TaskCheckitemFilesComponent
} from './view/home-board/dash-board-main-block/task-column/task-checkitem/task-checkitem-files/task-checkitem-files.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {FileUploadModule} from 'primeng/fileupload';
import {
  TaskFilesComponent
} from './view/home-board/dash-board-main-block/task-column/task-files/task-files.component';
import {InputSwitchModule} from 'primeng/inputswitch';
import {MentionModule} from 'angular-mentions';
import {UserMentionsModule} from '../../../../../app-misc/src/app/modules/mentions/user-mentions.module';
import {InputTextModule} from 'primeng/inputtext';
import {WidgetBarModule} from '../../../../../mobile/src/app/modules/widget-bar/widget-bar.module';
import {FilesMiscModule} from '../../../../../app-misc/src/app/modules/files-misc/files-misc.module';
import { ShortTasksListDialogComponent } from './view/home-board/dash-board-main-block/task-column/short-tasks-list-dialog/short-tasks-list-dialog.component';
import { InstallerQuotesComponent } from './view/home-board/dash-board-main-block/installer-quotes/installer-quotes.component';
import { InstallerQuoteComponent } from './view/home-board/dash-board-main-block/installer-quotes/installer-quote/installer-quote.component';
import {QuotesModule} from '../../../../../quotes/src/app/quotes.module';
import { InstallationQuoteDialogComponent } from './view/home-board/dash-board-main-block/installer-quotes/installer-quote/installation-quote-dialog/installation-quote-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';

@NgModule({
  declarations: [
    HomeBoardComponent,
    DashBoardLeftBlockComponent,
    DashBoardMainBlockComponent,
    TaskColumnComponent,
    TaskCardComponent,
    TaskEditDialogComponent,
    TasksListDialogComponent,
    TaskCommentsComponent,
    AlertsColumnComponent,
    ClientNfsColumnComponent,
    TaskCheckitemComponent,
    AddTaskCheckitemComponent,
    EditTaskCheckitemComponent,
    EditWorkOrderItemsComponent,
    TaskCheckitemTagsComponent,
    MentionsColumnComponent,
    TaskCheckitemFilesComponent,
    TaskFilesComponent,
    ShortTasksListDialogComponent,
    InstallerQuotesComponent,
    InstallerQuoteComponent,
    InstallationQuoteDialogComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    MentionModule,
    UserMentionsModule,
    ReactiveFormsModule,
    ButtonModule,
    MatButtonModule,
    MatRippleModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatFormFieldModule,
    OverlayPanelModule,
    CheckboxModule,
    MultiSelectModule,
    SelectButtonModule,
    CalendarModule,
    CheckboxModule,
    MiscModule,
    DropdownModule,
    ConfirmDialogModule,
    AccordionModule,
    MultiSelectModule,
    ListboxModule,
    SystemAlertsModule,
    ClientNfsModule,
    PaginatorModule,
    InputNumberModule,
    ProgressBarModule,
    TooltipModule,
    NotificationModule,
    MatProgressBarModule,
    FileUploadModule,
    InputSwitchModule,
    InputTextModule,
    WidgetBarModule,
    FilesMiscModule,
    QuotesModule,
    MatDialogModule
  ],
  exports: [
    TaskCardComponent
  ],
  entryComponents: [TaskEditDialogComponent, TasksListDialogComponent,
    TaskCommentsComponent, EditWorkOrderItemsComponent]
})
export class HomePageModule {
}
